export default __webpack_public_path__ + "static/media/investment_female.1d4d19de.png";